var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiBtn',{directives:[{name:"badge",rawName:"v-badge",value:({
    show: _vm.isShowFilterButtonBadge,
    style: {
      border: '2px solid var(--black-500)',
      top: '4px',
      right: '4px',
      height: '7px',
      width: '7px',
      backgroundColor: 'var(--badge-error-icon-dot-color)',
    },
  }),expression:"{\n    show: isShowFilterButtonBadge,\n    style: {\n      border: '2px solid var(--black-500)',\n      top: '4px',\n      right: '4px',\n      height: '7px',\n      width: '7px',\n      backgroundColor: 'var(--badge-error-icon-dot-color)',\n    },\n  }"}],staticClass:"filter-button",attrs:{"size":{
    default: 's',
    tablet: 'm',
  },"active":_vm.get_filterOptions.isOpen,"icon":"lobby/filter","color":"gray"},on:{"click":function($event){return _vm.write_filterOptions({ isOpen: true })}}},[_c('span',{staticClass:"filter-button__text",class:{ 'hidden-mob' : _vm.hiddenTextMob }},[_vm._v("\n    "+_vm._s(_vm.$tc('lobby.filter.title'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }